import Model, { hasMany, belongsTo, attr } from '@ember-data/model'
import { Type } from '@warp-drive/core-types/symbols'
import type School from 'teacher-ui-client/models/school'
import type Student from 'teacher-ui-client/models/student'
import type Teacher from 'teacher-ui-client/models/teacher'
import type { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import type StringTransform from 'teacher-ui-client/transforms/string'
import type BooleanTransform from 'teacher-ui-client/transforms/boolean'
import type DateTransform from 'teacher-ui-client/transforms/date'

export default class SchoolClass extends Model {
  @attr<StringTransform>('string') declare name: string

  @attr<StringTransform>('string') declare subscriptionType: SubscriptionType

  @attr<BooleanTransform>('boolean') declare mathseedsPrimeAccess: boolean

  @attr<BooleanTransform>('boolean') declare playroomAccess: boolean

  @attr<BooleanTransform>('boolean') declare gamesAccess: boolean

  @attr<BooleanTransform>('boolean') declare backgroundMusicDisabled: boolean

  @attr<DateTransform>('date') declare createdAt: Date

  @hasMany<Student>('student', { async: false, inverse: 'schoolClasses' }) declare students: Student[]

  @hasMany<Teacher>('teacher', { async: false, inverse: 'schoolClasses' }) declare teachers: Teacher[]

  @belongsTo<School>('school', { async: false, inverse: null }) declare school?: School

  get studentIds() {
    // @ts-expect-error - something wrong with relationship reference types
    return this.hasMany<Student, 'students'>('students').ids()
  }

  get studentCount() {
    return this.studentIds.length
  }

  get teacherNames(): string[] {
    return this.teachers?.map((teacher) => teacher.fullName) ?? []
  }

  get hasStudents() {
    return this.studentCount > 0
  }

  [Type] = 'school-class' as const
}
